import { useState } from "react";
import { useLang } from "../contexts/LanguageContext";
import { MapPin, Clock, Phone, Instagram, Facebook, ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";

const YAMAHA_BASE = {
    es: "https://www.yamaha-motor.eu/es/es",
    en: "https://www.yamaha-motor.eu/gb/en",
};

export default function Footer() {
    const { t, lang } = useLang();
    const [openProducts, setOpenProducts] = useState(false);

    return (
        <footer className="relative mt-32 border-t border-black/10 bg-neutral-100" data-testid="site-footer">
            <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
                <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
                    <div className="md:col-span-5">
                        <h3 className="font-display text-4xl font-bold">
                            LS<span style={{ color: "var(--ls-blue)" }}>39</span>
                        </h3>
                        <p className="mt-4 text-sm text-neutral-500 max-w-md">
                            {t.footer.tagline}
                        </p>
                        <div className="mt-8 flex gap-4">
                            <a
                                href="#"
                                className="border border-black/15 p-3 hover:border-black/30 transition-colors"
                                data-testid="footer-instagram"
                            >
                                <Instagram size={16} />
                            </a>
                            <a
                                href="#"
                                className="border border-black/15 p-3 hover:border-black/30 transition-colors"
                                data-testid="footer-facebook"
                            >
                                <Facebook size={16} />
                            </a>
                        </div>
                    </div>

                    <div className="md:col-span-4 space-y-4">
                        <p className="text-overline">Mallorca</p>
                        <a
                            href="https://maps.app.goo.gl/yZKUXKpj4gAj7nuy7"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-start gap-3 text-sm text-neutral-600 hover:text-neutral-900"
                        >
                            <MapPin size={16} className="mt-0.5 shrink-0" style={{ color: "var(--ls-terracotta)" }} />
                            <span>{t.footer.address}</span>
                        </a>
                        <div className="flex items-start gap-3 text-sm text-neutral-600">
                            <Clock size={16} className="mt-0.5 shrink-0" style={{ color: "var(--ls-terracotta)" }} />
                            <span>{t.footer.hours}</span>
                        </div>
                        <div className="flex items-start gap-3 text-sm text-neutral-600">
                            <Phone size={16} className="mt-0.5 shrink-0" style={{ color: "var(--ls-terracotta)" }} />
                            <a href="tel:+34871005111" className="hover:text-neutral-900">
                                {t.footer.phone}
                            </a>
                        </div>
                    </div>

                    <div className="md:col-span-3 space-y-3">
                        <p className="text-overline">Menu</p>

                        <Link to="/motos" className="block text-sm text-neutral-600 hover:text-neutral-900">
                            {t.nav.new}
                        </Link>
                        <Link to="/ocasion" className="block text-sm text-neutral-600 hover:text-neutral-900">
                            {t.nav.used}
                        </Link>

                        {/* Productos con submenu hover/click */}
                        <div
                            onMouseEnter={() => setOpenProducts(true)}
                            onMouseLeave={() => setOpenProducts(false)}
                        >
                            <button
                                onClick={() => setOpenProducts((o) => !o)}
                                className="flex w-full items-center justify-between text-sm text-neutral-600 hover:text-neutral-900"
                            >
                                {t.nav.products}
                                <ChevronDown
                                    size={12}
                                    className={`transition-transform duration-200 ${openProducts ? "rotate-180" : ""}`}
                                />
                            </button>
                            {openProducts && (
                                <div className="pl-4 flex flex-col gap-1 mt-1">
                                    <a href={`${YAMAHA_BASE[lang]}/accessories/`} target="_blank" rel="noopener noreferrer" className="text-sm text-neutral-500 hover:text-neutral-900">
                                        {t.nav.products_acc}
                                    </a>
                                    <a href={`${YAMAHA_BASE[lang]}/clothing-merchandise/clothing/`} target="_blank" rel="noopener noreferrer" className="text-sm text-neutral-500 hover:text-neutral-900">
                                        {t.nav.products_apparel}
                                    </a>
                                    <a href={`${YAMAHA_BASE[lang]}/service-support/parts-catalogue/`} target="_blank" rel="noopener noreferrer" className="text-sm text-neutral-500 hover:text-neutral-900">
                                        {t.nav.products_parts}
                                    </a>
                                </div>
                            )}
                        </div>

                        <Link to="/servicio" className="block text-sm text-neutral-600 hover:text-neutral-900">
                            {t.nav.service}
                        </Link>
                        <Link to="/contacto" className="block text-sm text-neutral-600 hover:text-neutral-900">
                            {t.nav.contact}
                        </Link>
                        <Link to="/admin/login" className="block text-sm text-neutral-500 hover:text-neutral-900 pt-3" data-testid="footer-admin-link">
                            {t.nav.admin}
                        </Link>
                    </div>
                </div>

                <div className="mt-16 flex flex-col gap-3 border-t border-black/10 pt-8 md:flex-row md:items-center md:justify-between">
                    <p className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-500">
                        © {new Date().getFullYear()} LS39 Mallorca · {t.footer.rights}
                    </p>
                    <p className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-600">
                        {t.footer.dealer}
                    </p>
                </div>
            </div>
        </footer>
    );
}
